import { Link, useLocation, useNavigate, Outlet } from "react-router-dom";
import { Home, BookOpen, Route, Puzzle, TrendingUp, CreditCard, User, LogOut, MessageCircle, Dumbbell } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";

const NAV = [
  { to: "/painel", label: "Início", icon: Home },
  { to: "/cursos", label: "Cursos", icon: BookOpen },
  { to: "/minha-jornada", label: "Minha Jornada", icon: Route },
  { to: "/puzzles", label: "Puzzles", icon: Puzzle },
  { to: "/meu-progresso", label: "Meu Progresso", icon: TrendingUp },
  { to: "/assinatura", label: "Assinatura", icon: CreditCard },
  { to: "/perfil", label: "Perfil", icon: User },
];

const MOBILE_NAV = [
  { to: "/painel", label: "Início", icon: Home },
  { to: "/cursos", label: "Cursos", icon: BookOpen },
  { to: "/puzzles", label: "Puzzles", icon: Puzzle },
  { to: "/meu-progresso", label: "Progresso", icon: TrendingUp },
  { to: "/perfil", label: "Perfil", icon: User },
];

export default function StudentLayout() {
  const loc = useLocation();
  const nav = useNavigate();
  const { user, logout } = useAuth();
  const { openWhatsapp } = useSettings();
  const isAdmin = user?.role === "admin";

  return (
    <div className="min-h-screen bg-chessup-bg flex">
      {/* Sidebar desktop */}
      <aside className="hidden lg:flex flex-col w-64 border-r border-chessup-border bg-chessup-deep sticky top-0 h-screen p-5">
        <Link to="/painel" className="mb-8"><Logo size={40} /></Link>
        <nav className="flex-1 space-y-1">
          {NAV.map((n) => {
            const active = loc.pathname === n.to || loc.pathname.startsWith(n.to + "/");
            const Icon = n.icon;
            return (
              <Link key={n.to} to={n.to} data-testid={`snav-${n.label}`}
                className={`flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors ${active ? "bg-chessup-turq/12 text-chessup-turq border border-chessup-turq/30" : "text-chessup-subtext hover:text-chessup-text hover:bg-chessup-card"}`}>
                <Icon className="h-4.5 w-4.5" style={{ width: 18, height: 18 }} /> {n.label}
              </Link>
            );
          })}
          {isAdmin && (
            <Link to="/admin" className="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm text-chessup-goldlight hover:bg-chessup-card mt-2" data-testid="snav-admin">
              <Dumbbell style={{ width: 18, height: 18 }} /> Área Admin
            </Link>
          )}
        </nav>
        <div className="space-y-2 pt-4 border-t border-chessup-border">
          <button onClick={() => openWhatsapp("student_support")} className="w-full flex items-center gap-2 text-sm text-chessup-subtext hover:text-chessup-turq px-3 py-2" data-testid="snav-whatsapp">
            <MessageCircle style={{ width: 18, height: 18 }} /> Suporte pelo WhatsApp
          </button>
          <button onClick={() => { logout(); nav("/"); }} className="w-full flex items-center gap-2 text-sm text-chessup-subtext hover:text-chessup-text px-3 py-2" data-testid="snav-logout">
            <LogOut style={{ width: 18, height: 18 }} /> Sair
          </button>
        </div>
      </aside>

      <div className="flex-1 min-w-0 pb-20 lg:pb-0">
        <Outlet />
      </div>

      {/* Bottom nav mobile */}
      <nav className="lg:hidden fixed bottom-0 inset-x-0 z-30 glass border-t border-chessup-border flex justify-around py-2" data-testid="mobile-bottom-nav">
        {MOBILE_NAV.map((n) => {
          const active = loc.pathname === n.to;
          const Icon = n.icon;
          return (
            <Link key={n.to} to={n.to} className={`flex flex-col items-center gap-0.5 text-[10px] px-2 ${active ? "text-chessup-turq" : "text-chessup-subtext"}`}>
              <Icon style={{ width: 20, height: 20 }} /> {n.label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
